import Konva from 'konva';
import { IRect } from 'konva/cmj/types';

const getRectRelativeToStage = (node: Konva.Node): IRect => {
  // @ts-expect-error seems to be an issue with Konva's types as this is valid
  return node.getClientRect({ relativeTo: node.getStage() });
};

export default getRectRelativeToStage;
